import React, { useEffect, useRef, useState } from "react";

type PromoIframeProps = {
    iframeUrl: string;
    tokenData: {
        accessToken: string | null;
        lob: string;
        env: string;
        [key: string]: any;
    };
};

const PromoIframe: React.FC<PromoIframeProps> = ({ iframeUrl, tokenData }) => {
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const [iframeLoaded, setIframeLoaded] = useState(false);
    const hasSentRef = useRef(false);

    useEffect(() => {
        if (!iframeRef.current || !iframeLoaded || !tokenData) return;
        try {
            const targetOrigin = new URL(iframeUrl).origin;

            if (!hasSentRef.current) {
                iframeRef.current.contentWindow?.postMessage(tokenData, targetOrigin);
                hasSentRef.current = true;
            }
        } catch (err) {
            console.error("Failed to postMessage to iframe:", err);
        }
    }, [iframeLoaded, tokenData, iframeUrl]);

    return (
        <iframe
            ref={iframeRef}
            src={iframeUrl}
            title="Promo Portal"
            onLoad={() => {
                hasSentRef.current = false;
                setIframeLoaded(true);
            }}
            style={{
                width: "100%",
                height: "100vh",
                border: "none",
            }}
        />
    );
};

export default PromoIframe;
